import React, { useState, useEffect } from 'react';
import taxi from './belfast-cab-tour-cab-tours.png';
import '../Styles.css';

const Packages = () => {
  // State to store the current scroll position
  const [scrollTop, setScrollTop] = useState(0);

  // Set up a scroll event listener to track scroll position
  useEffect(() => {
    const handleScroll = () => {
      setScrollTop(window.scrollY); // Get the scroll position
    };

    window.addEventListener('scroll', handleScroll); // Add event listener
    return () => {
      window.removeEventListener('scroll', handleScroll); // Clean up on component unmount
    };
  }, []);

  // Array of tour packages
  const tourPackages = [
    { name: 'Belfast Murals Tour', duration: '1.5 hours', price: '£60' },
    { name: 'Belfast Political Taxi Tour', duration: '1.5 hours', price: '£60' },
    { name: 'Giant’s Causeway and Coastal Tour', duration: '6 hours', price: '£300' },
    { name: 'Dark Hedges and Glens of Antrim Tour', duration: '6 hours', price: '£300' },
    { name: 'Game of Thrones Taxi Tour', duration: '2 hours', price: '£100' },
    { name: 'C.S. Lewis Cab Tour', duration: '2 hours', price: '£100' },
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh', // Ensure full viewport height
        margin: 0,
        padding: 0,
      }}
    >
      {/* Header Section */}
      <header className="Packages-header">
        <div className="animation-wrapper">
          <img
            src={taxi}
            className="taxi"
            alt="taxi"
            style={{
              top: '-2%', // Adjust this value to raise the taxi
              transform: `translateY(-${scrollTop / 100}%)`, // Dynamic scroll effect
            }}
          />
        </div>
      </header>

      {/* Main Content */}
      <h1 className="Packages-header1" style={{ textAlign: 'center', marginBottom: 0 }}>
        <p>Below is a list of popular, pre-planned packaged taxi tours we offer in Belfast and Northern Ireland.
          <br /><br />
          Prices shown are minimum and based on 1-2 passengers. 
          <br /><br />
          Any more than 2 passengers (3/4/5/6/7), we charge an additional £10 per passenger.
          <br /><br />
          Note: personal/bespoke tours can also be arranged.
        </p>
          <br /><br />
        <table
          style={{
            width: '100%',
            margin: 'auto',
            borderCollapse: 'collapse',
            backgroundColor: '#000',
            color: '#fff',
            fontSize: '14px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.8)',
          }}
        >
          <thead>
            <tr
              style={{
                textAlign: 'center',
                backgroundColor: '#FFC107',
                color: '#000',
              }}
            >
              <th
                style={{
                  padding: '8px',
                  border: '1px solid #fff',
                  width: '40%',
                }}
              >
                Tours
              </th>
              <th
                style={{
                  padding: '8px',
                  border: '1px solid #fff',
                  width: '30%',
                }}
              >
                Duration
              </th>
              <th
                style={{
                  padding: '8px',
                  border: '1px solid #fff',
                  width: '30%',
                  textAlign: 'center',
                }}
              >
                Price
              </th>
            </tr>
          </thead>
          <tbody>
            {tourPackages.map((tour, index) => (
              <tr
                key={index}
                style={{
                  borderBottom: '1px solid #fff',
                }}
              >
                <td
                  style={{
                    padding: '8px',
                    border: '1px solid #fff',
                    textAlign: 'left',
                  }}
                >
                  {tour.name}
                </td>
                <td
                  style={{
                    padding: '8px',
                    border: '1px solid #fff',
                    textAlign: 'center',
                  }}
                >
                  {tour.duration}
                </td>
                <td
                  style={{
                    padding: '8px',
                    border: '1px solid #fff',
                    textAlign: 'center',
                  }}
                >
                  {tour.price}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </h1>

      {/* Footer Section */}
      <footer
        style={{
          textAlign: 'center',
          padding: '1rem',
          backgroundColor: '#333',
          color: '#fff',
          marginTop: 'auto', // Push footer to the bottom if content is short
        }}
      >
        &copy; 2025{' '}
        <a
          href="https://belfastcabtour.com"
          style={{
            color: '#fff',
            textDecoration: 'none',
          }}
        >
          belfastcabtour.com
        </a>
        . All rights reserved.
      </footer>
    </div>
  );
};

export default Packages;
